import React from 'react';
export const GroupContext = /*#__PURE__*/React.createContext(null);